import React, {useEffect} from 'react';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import {filterTypes} from 'src/components/elements/account/AccountHistoryList';
import {
  HistoryComponent,
  HistoryComponentProps,
} from 'src/components/elements/account/newHistoryUI/historyComponent';

const MarketHistoryList = (props: HistoryComponentProps) => {
  useEffect(() => {
    const filterValue = filterTypes.marketPurchase;
    FirebaseAnalytic.trackEvent(
      'useEffect:componentDidMount',
      'MarketHistoryList',
      {
        ...props,
        filterValue,
      },
    );
  }, []);
  return (
    <HistoryComponent historyfilter={filterTypes.marketPurchase} {...props} />
  );
};

export default MarketHistoryList;
